export function PanelCard({ className = "", children }) {
  return (
    <section
      className={[
        "rounded-[28px] border border-[#d9e5ff] bg-white/90 shadow-[0_22px_60px_rgba(13,55,148,0.12)] backdrop-blur-sm",
        className,
      ].join(" ")}
    >
      {children}
    </section>
  );
}